import type {
  InvoiceReportFormInputResponseInputAdditionalValuesItem,
  InvoiceReportFormInputValue,
  InvoiceRegistrationNumberFieldAdditionalValues,
  ReportBusinessDocument,
} from 'ap-openapi';

export type FormInputValue = InvoiceReportFormInputValue;

export type FormInputAdditionalValuesItem =
  InvoiceReportFormInputResponseInputAdditionalValuesItem;

export type FormInputItem = {
  id: string;
  input_additional_values?: FormInputAdditionalValuesItem[] | null;
  input_values?: FormInputValue[] | null;
  label: string;
  type: string;
};

export type PaymentInfoData = {
  report_form_inputs?: FormInputItem[] | null;
};

export type SmartListViewDetailsOverrides = {
  isItemVisible?: (item: FormInputItem) => boolean;
};

export enum ActiveFileType {
  INVOICE = 'invoice',
  BUSINESS_DOCUMENT = 'business_document',
}

export type ActiveFileId = {
  type: ActiveFileType;
  id: string;
  fileId?: string;
} | null;

export interface ProcessedBusinessDocument
  extends ReportBusinessDocument,
    InvoiceRegistrationNumberFieldAdditionalValues {
  documentTypeKey: string;
  label: string;
  href: string;
  fileNameParts: { name: string; extension: string };
}
